import Vue from 'vue';
import axios from 'axios';
import moment from 'moment';
import '../../../../filters';
import { Datetime } from 'vue-datetime';
import 'vue-datetime/dist/vue-datetime.css';
import { DateTime } from "luxon";

export default {
  name: 'sampleAnalysisDetails',
  components: {
    datetime: Datetime,
    DateTime,
    DteTme: require('@/customcontrols/dateTimePicker.vue').default,
    DataGridComp: require('../../../../customcontrols/datagrid.vue').default,
  },
  props: ['dataObj'],
  data: function () {
    return {
      showEmployeesDialog: false,
      employeesConfig: {},
      employeesPageingOption: {
        pageSize: 1000,
        total: 0,
        page: 1
      },
    }
  },
  created() {
    console.log("data Obj", this.dataObj);
    this.employeesConfigration();

    //find name from id
    this.dataObj.appData['employee'] = '';
    for (let elem of this.dataObj.appData.employees) {
      if (elem.employeeId == this.dataObj.appData.employeeId) {
        this.dataObj.appData['employee'] = elem.displayString;
        return;
      }
    }
  },
  watch: {
    
  },
  methods: {
    employeesConfigration() {
      this.employeesConfig['keyColumn'] = 'displayString';
      this.employeesConfig['pageOptions'] = this.employeesPageingOption;
      this.employeesConfig['cols'] = [];
      this.employeesConfig['cols'].push({ dataField: 'displayString', caption: this.$t('lims.approvedBy') });
      this.employeesConfig['cols'].push({ dataField: 'stationName', caption: this.$t('lims.post') });
      this.employeesConfig['cols'].push({ dataField: 'email', caption: this.$t('lims.email') });
    },
    rowSelected(info) {
      this.dataObj.appData.employeeId = info.data.employeeId;
      this.dataObj.appData['employee'] = info.data.displayString;
      this.employeesDialog(false);
    },
    employeesDialog(bool) {
      this.showEmployeesDialog = bool;
    },
    pageChange() { },
    validateAppData() {
      return true;
    },
  },
  
}

